import { render, staticRenderFns } from "./softbim.vue?vue&type=template&id=305a9983&scoped=true"
import script from "./softbim.vue?vue&type=script&lang=js"
export * from "./softbim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305a9983",
  null
  
)

export default component.exports